import { render, staticRenderFns } from "./platform_config.vue?vue&type=template&id=3a5dc766&scoped=true"
import script from "./platform_config.vue?vue&type=script&lang=js"
export * from "./platform_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5dc766",
  null
  
)

export default component.exports